import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { AsyncPipe, NgComponentOutlet, NgStyle } from '@angular/common';
import {
  ContainerItemModel,
  ContainerModel,
} from '@app/models/server/layout.model';
import { COMP_STATES } from '@app/constants/app-settings';
import { Observable, of } from 'rxjs';
import { B2bDynamicLoaderPipe } from '@app/b2b-dynamic-lib/pipes/b2b-dynamic-loader-pipe.pipe';

@Component({
  selector: 'app-b2b-slider-item',
  templateUrl: './b2b-slider-item.component.html',
  styleUrls: ['./b2b-slider-item.component.scss'],
  // animations: [animationSkeleton],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgStyle, AsyncPipe, NgComponentOutlet, B2bDynamicLoaderPipe],
})
export class B2bSliderItemComponent implements OnInit, OnDestroy {
  @Input() compData: {
    container?: ContainerModel;
    containerItem?: ContainerItemModel;
    loaded?: (value: any) => void;
  };

  $commonContainer: Observable<ContainerModel | ContainerItemModel>;

  ngOnInit() {
    if (this.compData?.containerItem) {
      this.$commonContainer = of(this.compData?.containerItem);
    } else {
      this.$commonContainer = of(this.compData?.container);
    }

    if (this.compData?.loaded) {
      this.compData?.loaded(COMP_STATES?.LOADED);
    }
  }

  onLoaded() {}

  onComponentLoaded() {}

  ngOnDestroy(): void {}
}
